import React, {useRef, useState} from 'react'
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";
import {useUploadDeviceExcel} from "../services/device";
import LinearProgress from "@material-ui/core/LinearProgress";
import {STATIC_URL} from "../config/urls";


export default function UploadDeviceListButton({model}) {

    const uploadExcel = useUploadDeviceExcel();

    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [resultFile, setResultFile] = useState(null);

    const formRef = useRef();

    function handleDelete() {
        setSelectedFile(null);
        formRef.current.reset()

    }

    function onFileChange(event) {
        setSelectedFile(event.target.files[0]);
    }

    async function handleSubmit() {
        setLoading(true);
        const file = await uploadExcel(selectedFile, model);
        setResultFile(file);
        setLoading(false);
        formRef.current.reset()
    }


    function handleDownload() {
        setResultFile(null);
        setSelectedFile(null);

    }


    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <div>
                    <form ref={formRef}>
                        <input
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            className={classes.input}
                            id="contained-button-file"
                            multiple
                            onChange={onFileChange}
                            type="file"
                        />
                    </form>
                    {!selectedFile ?
                        <label htmlFor="contained-button-file">
                            <Button variant="contained" color="primary" size='large' component="span">افزودن لیست جدید</Button>
                        </label> : resultFile ?
                            <Button variant="contained" color="primary" size='large' onClick={handleDownload}
                                    href={STATIC_URL + resultFile}>دانلود
                                اکسل کد‌جعبه</Button> :
                            <Button variant="contained" color="primary" size='large' onClick={handleSubmit}>ارسال</Button>
                    }


                </div>
            </Grid>
            <Grid item xs={6} className={classes.fileName}>
                {selectedFile && <Chip
                    label={selectedFile.name}
                    onDelete={handleDelete}
                />}

            </Grid>
            {loading && <Grid item xs={12}>
                <LinearProgress variant="indeterminate"/>
            </Grid>}
            {resultFile === false && <Grid item xs={12}>
                خطایی رخ داده است
            </Grid>}


        </Grid>
    )
}


const useStyles = makeStyles((theme) => ({
    input: {
        display: 'none',
    },
    fileName: {
        textAlign: 'right'
    }
}));
